export default __webpack_public_path__ + "static/media/DB_3.7fed44b6.png";